
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/team/[id]",
      function () {
        return require("private-next-pages/shop/team/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/team/[id]"])
      });
    }
  